import api from './api';
import { Order, ShipmentItem } from '../types';
import { getCarrierClass } from './carrierUtils';

export interface ShippingMethod {
  id: number;
  name: string;
  method_code: string;
}

export interface FdcRecipient {
  companyName: string;
  country: string;
  postalCode: string;
  addressRegion: string;
  addressLocality: string;
  address2: string;
  address1: string;
  phone: string;
  lastName: string;
  firstName: string;
  email: string;
}

export interface FdcItem {
  quantity: number;
  sku: string;
  declaredValue: string;
}

export interface FdcPayload {
  merchantOrderId: string;
  shippingMethod: string;
  recipient: FdcRecipient;
  items: FdcItem[];
  notes: string;
}

export const getFdcShippingMethods = async (): Promise<ShippingMethod[]> => {
  const response = await api.get('/fdc/fdc-shipment-methods');
  return response.data.methods || [];
};

export const sendToFdc = async (payload: FdcPayload): Promise<any> => {
  console.log('Sending to FDC:', payload);
  const response = await api.post('/fdc/send-to-fdc', payload);
  return response;
};

export const createShipmentRecord = async (
  orderId: number,
  warehouseId: number,
  carrier: string,
  trackingNumber: string,
  dateShipped: string,
  reference: string,
  shipmentReference: string,
  items: { order_item_id: number; product_id: number; product_name: string; sku: string; gtin: string; instance_number: number }[]
): Promise<any> => {
  const response = await api.post('/shipments', {
    action: 'create',
    order_id: orderId,
    data: {
      warehouse_id: warehouseId,
      carrier,
      tracking_number: trackingNumber,
      date_shipped: dateShipped,
      shipment_reference: reference,
      items,
    },
  });
  return response;
};

export const updateOrderStatus = async (orderId: number, status: string): Promise<any> => {
  const response = await api.post('/update-order-status', {
    order_id: orderId,
    status,
  });
  return response;
};

export const addOrderNote = async (
  orderId: number,
  note: string,
  addedBy: string,
  isCustomerNote: boolean
): Promise<any> => {
  const response = await api.post('/add-order-note', {
    order_id: orderId,
    note,
    added_by: addedBy,
    is_customer_note: isCustomerNote,
  });
  return response;
};

export const calculateShippedQuantities = (
  shipments: any[],
  selectedItems: { [key: string]: number },
  orderId: number
): { [itemId: number]: number } => {
  const shippedQuantities: { [itemId: number]: number } = {};

  // Count previously shipped items
  shipments.forEach((s: any) => {
    s.items.forEach((si: ShipmentItem) => {
      shippedQuantities[si.order_item_id] = (shippedQuantities[si.order_item_id] || 0) + 1;
    });
  });

  // Add the items from this shipment
  Object.keys(selectedItems).forEach(itemKey => {
    const [itemId] = itemKey.split('-').map(Number);
    shippedQuantities[itemId] = (shippedQuantities[itemId] || 0) + selectedItems[itemKey];
  });

  return shippedQuantities;
};

